import logo from '../images/icon.svg';
export const Header = () => {
  return (
    <div id="header">
      <img id="logo" src={logo} alt="logo"/> 
      <p>Bed Word</p>
    </div>
  )
}
